import {keyedObjToArr} from './index';



export const getActivityScore = (lesson, activity) => {
    return lesson[activity] ? lesson[activity] : null;
};

export const getReallyWritingDivisor = (lesson) => {
    let lessonNumber = lesson.name.split('.')[0];
    if(lessonNumber && lessonNumber === '2'){
        return 2;
    }
    else if(lessonNumber && lessonNumber === '3'){
        return 1;
    }
    else if(lessonNumber && lessonNumber === '4'){
        return 2;
    }

    return 3; // Default for Really Writing
};

export const getSoundBlendDivisor = (lesson) => {
    let lessonNumber = lesson.name.split('.')[0];
    return 100; // Default for Really Writing
};

export const getPercent = (score, outOf) => {
    return score && outOf ? Math.round((score / outOf) * 100) : null;
};

export const getText = (score, outOf) => {
    return score && outOf ? `${score}/${outOf}` : '';
};

const getOrdinalValue = (score) => {
    if (score === 1) return '1st';
    else if (score === 2) return '2nd';
    else if (score === 3) return '3rd';
};

export const soundBlend = (lesson) => {
    let divisor = getSoundBlendDivisor(lesson);
    let soundblend1 = getActivityScore(lesson, 'soundblend1');
    let soundblend2 = getActivityScore(lesson, 'soundblend2');

    let soundblend1json = getActivityScore(lesson, 'soundblend1json');
    let soundblend2json = getActivityScore(lesson, 'soundblend2json');

    if (soundblend1json || soundblend2json) {
        return {
            'one': {
                'raw': soundblend1json.score,
                'percent': getPercent(soundblend1json.score, soundblend1json.outOf),
                'divisor': soundblend1json.outOf,
                'text': getText(soundblend1json.score, soundblend1json.outOf)
            },
            'two':{
                'raw': soundblend2json.score,
                'percent': getPercent(soundblend2json.score, soundblend2json.outOf),
                'divisor': soundblend2json.outOf,
                'text': getText(soundblend2json.score, soundblend2json.outOf)
            }
        };
    }

    return {
        'one':{
            'raw': soundblend1,
            'percent': Math.round((soundblend1 / divisor) * 100),
            'divisor': divisor,
            'text': soundblend1 ? soundblend1 + '%': ''
        },
        'two':{
            'raw': soundblend2,
            'percent': Math.round((soundblend2 / divisor) * 100),
            'divisor': divisor,
            'text': soundblend2 ? soundblend2 + '%': ''
        }
    };
};

export const wordBuilder = (lesson) => {
    let divisor = 100;
    let wordbuilder1 = getActivityScore(lesson, 'wordbuilder1');

    const wordbuilder1json = getActivityScore(lesson, 'wordbuilder1json');

    if (wordbuilder1json) {
        const {
            score,
            outOf,
        } = wordbuilder1json;

        return {
            'one':{
                'raw': score,
                'percent': getPercent(score, outOf),
                'divisor': outOf,
                'text': getText(score, outOf),
            }
        };
    }

    return {
        'one':{
            'raw': wordbuilder1,
            'percent': Math.round((wordbuilder1 / divisor) * 100),
            'divisor': divisor,
            'text': wordbuilder1 ? wordbuilder1 + '%': ''
        }
    };
};

export const soundFarm = (lesson) => {
    let divisor = 100;
    let soundfarm2 = getActivityScore(lesson, 'soundfarm2');
    let soundfarm1json = getActivityScore(lesson, 'soundfarm1json');

    if (soundfarm1json) {
        const {
            score,
            outOf
        } = soundfarm1json;

        return {
            'two': {
                'raw': score,
                'percent': getPercent(score, outOf),
                'divisor': outOf,
                'text': getText(score, outOf),
            }
        };
    }

    return {
        'two':{
            'raw': soundfarm2,
            'percent': getPercent(soundfarm2, divisor),
            'divisor': divisor,
            'text': soundfarm2 ? soundfarm2 + '%': ''
        }
    };
};

export const traceRace = (lesson) => {
    let divisor = 3;
    let tracerace1 = getActivityScore(lesson, 'tracerace1');
    let tracerace2 = getActivityScore(lesson, 'tracerace2');

    return {
        'one':{
            'raw': tracerace1,
            'percent': tracerace1 ? Math.round(((4 - tracerace1) / divisor) * 100) : null,
            'divisor': divisor,
            'text': tracerace1 ? getOrdinalValue(tracerace1) : ''
        },
        'two':{
            'raw': tracerace2,
            'percent': tracerace2 ? Math.round(((4 - tracerace2) / divisor) * 100) : null,
            'divisor': divisor,
            'text': tracerace2 ? getOrdinalValue(tracerace2) : ''
        }
    };
};

export const reallyWriting = (lesson) => {
    let divisor = getReallyWritingDivisor(lesson);
    let reallyWriting2 = getActivityScore(lesson, 'reallywriting2');

    const reallywriting1json = getActivityScore(lesson, 'reallywriting1json');

    if (reallywriting1json) {
        const {
            score,
            outOf,
        } = reallywriting1json;

        return {
            'two': {
                'raw': score,
                'percent': getPercent(score, outOf),
                'divisor': outOf,
                'text': getText(score, outOf),
            }
        };
    }

    return {
        'two':{
            'raw': reallyWriting2,
            'percent': Math.round((reallyWriting2 / divisor) * 100),
            'divisor': divisor,
            'text': reallyWriting2 ? reallyWriting2 : ''
        }
    };
};

export const reallyReading = (lesson) => {
    let divisor = 100;
    let reallyReading1 = getActivityScore(lesson, 'reallyreading1');

    return {
        'one':{
            'raw': reallyReading1,
            'percent': Math.round((reallyReading1 / divisor) * 100),
            'divisor': divisor,
            'text': reallyReading1 ? reallyReading1 + '%': ''
        }
    };
};



export const calcPQLessonAverage = (lesson) =>{
    let sumTotal = 0;
    let divisor = 0;

    let sb = soundBlend(lesson);
    let sf = soundFarm(lesson);
    let tr = traceRace(lesson);
    let rw = reallyWriting(lesson);
    let rr = reallyReading(lesson);

    // Sound Blend
    if (sb.one.raw){
        sumTotal += sb.one.percent;
        divisor += 1;
    }
    if (sb.two.raw){
        sumTotal += sb.two.percent;
        divisor += 1;
    }

    // Trace Race
    if (tr.one.raw){
        sumTotal += tr.one.percent;
        divisor += 1;
    }
    if (tr.two.raw){
        sumTotal += tr.two.percent;
        divisor += 1;
    }

    // Sound Farm
    if (sf.two.percent){
        sumTotal += sf.two.percent;
        divisor += 1;
    }

    // Really Writing
    if (rw.two.raw){
        sumTotal += rw.two.percent;
        divisor += 1;
    }

    // Really Reading
    if (rr.one.raw){
        sumTotal += rr.one.percent;
        divisor += 1;
    }

    if (divisor === 0){
      return null;
    }

    return Math.round((sumTotal / divisor));
};

export const calcPFLessonAverage = (lesson) =>{
    let sumTotal = 0;
    let divisor = 0;

    // Sound Farm
    if (lesson.soundfarm1){
        sumTotal += lesson.soundfarm1;
        divisor += 1;
    }

    if(lesson.tractor1){
        sumTotal += lesson.tractor1;
        divisor += 1;
    }
    if(lesson.horse1){
        sumTotal += lesson.horse1;
        divisor += 1;
    }
    if(lesson.apple1){
        sumTotal += lesson.apple1;
        divisor += 1;
    }
    if(lesson.sheep1){
        sumTotal += lesson.sheep1;
        divisor += 1;
    }
    if(lesson.popcorn1){
        sumTotal += lesson.popcorn1;
        divisor += 1;
    }
    if(lesson.egg1){
        sumTotal += lesson.egg1;
        divisor += 1;
    }
    if(lesson.hay1){
        sumTotal += lesson.hay1;
        divisor += 1;
    }
    if(lesson.manipulation1){
        sumTotal += lesson.manipulation1;
        divisor += 1;
    }
    if(lesson.deletion1){
        sumTotal += lesson.deletion1;
        divisor += 1;
    }

    if (divisor === 0){
      return null;
    }

    return Math.round((sumTotal / divisor));
};


export const metricsForPQLesson = (lesson) => {
    return {
        sf: soundFarm(lesson),
        wb: wordBuilder(lesson),
        tr: traceRace(lesson),
        sb: soundBlend(lesson),
        rw: reallyWriting(lesson),
        rr: reallyReading(lesson)
    };
};

export const metricsForPF = (metrics) => {
    let returnData = {
        tractor: [],
        horse: [],
        apple: [],
        sheep: [],
        popcorn: [],
        egghay: [],
        manipulation: [],
        deletion: []
    };

    metrics.forEach((metric) => {
        if('tractor1' in metric){
            returnData.tractor.push(metric);
        }
        else if ('horse1' in metric){
            returnData.horse.push(metric);
        }
        else if('apple1' in metric){
            returnData.apple.push(metric);
        }
        else if('sheep1' in metric){
            returnData.sheep.push(metric);
        }
        else if('popcorn1' in metric){
            returnData.popcorn.push(metric);
        }
        else if('egg1' in metric && 'hay1' in metric){
            returnData.egghay.push(metric);
        }
        else if('manipulation1' in metric){
            returnData.manipulation.push(metric);
        }
        else if('deletion1' in metric){
            returnData.deletion.push(metric);
        }
        else if('tractor1json' in metric){
            returnData.tractor.push(metric);
        }
        else if ('horse1json' in metric){
            returnData.horse.push(metric);
        }
        else if('apple1json' in metric){
            returnData.apple.push(metric);
        }
        else if('sheep1json' in metric){
            returnData.sheep.push(metric);
        }
        else if('popcorn1json' in metric){
            returnData.popcorn.push(metric);
        }
        else if('egg1json' in metric && 'hay1json' in metric){
            returnData.egghay.push(metric);
        }
        else if('manipulation1json' in metric){
            returnData.manipulation.push(metric);
        }
        else if('deletion1json' in metric){
            returnData.deletion.push(metric);
        }
    });
    return returnData;
};

export const sortMetrics = (metrics) => {
    return keyedObjToArr(metrics).sort(function (a,b){
        return (+(a.name.split('.')[0])) - (+(b.name.split('.')[0]));
    });
};



// WEBPACK FOOTER //
// ./js/util/metrics.js